import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { BlogFeedResponse } from "./newsFeed.js";

const BLOG_FEED_URL = "https://eokaraebrkunkhvehmsp.supabase.co/functions/v1";

export const blogFeedApi = createApi({
	reducerPath: "blogFeedApi",
	baseQuery: fetchBaseQuery({ baseUrl: BLOG_FEED_URL }),
	endpoints: (builder) => ({
		getBlogFeed: builder.query<
			BlogFeedResponse,
			{ locale: "sv" | "en"; limit: number }
		>({
			query: (params) => ({ url: "blog-feed", params }),
		}),
	}),
});

export const { useGetBlogFeedQuery } = blogFeedApi;
